import { useState } from 'react';

function FAQSection({ title, subtitle, items }) {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-10 sm:py-[60px] bg-dark">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="font-montserrat text-xs tracking-[0.3em] uppercase text-gold mb-4">{subtitle}</p>
          <h2 className="font-playfair text-4xl sm:text-5xl font-bold gold-gradient-text">{title}</h2>
        </div>

        <div className="space-y-3">
          {items.map((item, i) => (
            <div key={i} className="gold-border gold-border-hover transition-all duration-300">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex justify-between items-center p-5 text-left"
              >
                <span className="font-montserrat text-xl text-white pr-4">{item.q}</span>
                <span className="text-gold text-2xl flex-shrink-0">{open === i ? '−' : '+'}</span>
              </button>
              {open === i && (
                <div className="px-5 pb-5">
                  <p className="font-montserrat text-lg text-white/60 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
